import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";

/**
 * A simple confirmation dialog.
 *
 * props:
 *  - open: boolean
 *  - title: string
 *  - message: string
 *  - onCancel: () => void
 *  - onConfirm: () => void
 *  - confirmText: string (default "Sí")
 *  - cancelText: string (default "No")
 */
const ConfirmDialog = ({
  open,
  title,
  message,
  onCancel,
  onConfirm,
  processing = false,
  confirmText = "Sí",
  cancelText = "No",
}) => (
  <Dialog
    open={open}
    keepMounted
    onClose={onCancel}
    aria-describedby="alert-dialog-slide-description"
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-slide-description">
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="error" variant="outlined" disabled={processing}>
        {cancelText}
      </Button>
      <Button onClick={onConfirm} color="primary" variant="contained" disabled={processing}>
        {confirmText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
